<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark>
            <v-toolbar-title>Juzgados
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.nombre"  label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.clave" label="Clave" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model.trim="editedItem.municipio_id"
                            label="Municipio"
                            :items="listMunicipios"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            v-model.trim="editedItem.materia_id"
                            label="Materia"
                            :items="ListMaterias"
                            item-text="nombre"
                            item-value="id"
                            @change="clearZona()"
                            :rules="notBlankRules">
                          </v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.materia_id && editedItem.materia_id== 7">
                          <v-select
                            v-model.trim="editedItem.distrito_id"
                            label="Distrito"
                            :items="listDistritos"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.materia_id && editedItem.materia_id != 8 && editedItem.materia_id != 7">
                          <v-select
                            v-model.trim="editedItem.partido_judicial_id"
                            label="Partido Judicial"
                            :items="listPartidos"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.materia_id == 8">
                          <v-select
                            v-model.trim="editedItem.region_id"
                            label="Región"
                            :items="listRegiones"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" class="ma-2 white--text" color="yellow darken-2" @click.native="editJuzgado(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                          <v-btn v-else class="ma-2 white--text" color="yellow darken-2" @click.native="addJuzgado(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="listJuzgados"
            class="elevation-1"
            light
            actions
            :loading="loading"
            
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-autocomplete
                  class="mx-4 mt-8"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listPartidos"
                  v-model="partido_judicial"
                  label="Partidos Judiciales"
                  clearable
                  @change="onFilterChange"
                ></v-autocomplete>
                <v-autocomplete
                  class="mx-4 mt-8"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listDistritos"
                  v-model="distrito"
                  label="Distritos"
                  clearable
                  @change="onFilterChange"
                ></v-autocomplete>
                <v-autocomplete
                  class="mx-4 mt-8"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listRegiones"
                  v-model="region"
                  label="Regiones laborales"
                  clearable
                  @change="onFilterChange"
                ></v-autocomplete>
                <v-autocomplete
                  class="mx-4 mt-8"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="ListMaterias"
                  v-model="materia"
                  label="Materia"
                  clearable
                  @change="onFilterChange"
                ></v-autocomplete>
              </v-toolbar>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
                >
                  mdi-check-bold
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
                >
                  mdi-minus
              </v-icon>
            </template>
            <!-- <template v-slot:item.permissions="{ item }">
              <v-chip class="ma-1" small v-for="item in item.permissions" style="min-width: 88px;">
                {{ item.descripcion }}
              </v-chip>
            </template> -->
            <template v-slot:item.action="{ item }">
              <v-icon
              color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon
              v-if="!item.deleted_at" color="red"  @click="deleteJuzgado(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="pagination.total > 1">
            <v-pagination 
              v-model="pagination.current_page" 
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
            >

            </v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      pagination: { 
        current_page: 1,
        total: 0,
      },
      itemsPerPage: 15,
      // changePassword:false,
      // mask: '##########',
      // celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        { text: 'Id', value: 'id', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Materia', value: 'materia_data', sortable: true },
        { text: 'Clave', value: 'clave', sortable: true },
        // { text: 'Permisos', value: 'permissions', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', width: '15%' }
      ],
      editedIndex: -1,
      activo: true,
      listJuzgados: [],
      listDistritos: [],
      listRegiones: [],
      editedItem: {
        municipio_id:'',
        materia_id:'',
        partido_judicial_id:'',
        distrito_id: '',
        region_id:'',
        nombre:'',
        clave:'',
      },
      defaultItem: {
        municipio_id:'',
        materia_id:'',
        partido_judicial_id:'',
        distrito_id: '',
        region_id:'',
        nombre:'',
        clave:'',
      },
      /* filters */
      partido_judicial:'',
      distrito:'',
      region:'',
      materia:'',
      /* end filters */
      // message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  watch: {
    'editedItem.materia_id': function (val) {
        // this.distrito_id = ''
        if (val && this.editedIndex == -1) {
          this.editedItem.partido_judicial_id = ''
          this.editedItem.distrito_id = ''
          this.editedItem.region_id = ''
        }
        if(!val){
          return this.$refs.form.resetValidation()
        }


    },
    'editedItem.partido_judicial_id': function (val) {
        if (val && this.editedIndex > -1) {
          this.editedItem.distrito_id = ''
          this.editedItem.region_id = ''
        }
        if(!val){
          return this.$refs.form.resetValidation()
        }
    },
    'editedItem.distrito_id': function (val) {
        if (val && this.editedIndex > -1) {
          this.editedItem.partido_judicial_id = ''
          this.editedItem.region_id = ''
        }
        if(!val){
          return this.$refs.form.resetValidation()
        }
    },
    'editedItem.region_id': function (val) {
        if (val && this.editedIndex > -1) {
          this.editedItem.partido_judicial_id = ''
          this.editedItem.distrito_id = ''
        }
        if(!val){
          return this.$refs.form.resetValidation()
        }
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Juzgado' : 'Editar Juzgado'
    },
    ...mapGetters([
      "permisosList", "listMunicipios", "ListMaterias", "listPartidos"
    ]),
  },
  mounted() {
    this.getJuzgados();
    this.getMunicipios();
    this.getMaterias();
    this.getPartidos();
    this.getDistritos();
    this.getRegiones();
  },
  methods: {
    getJuzgados() {
      this.loading = true;
      this.filtros = {
        partido_judicial_id: this.partido_judicial ? this.partido_judicial.id : undefined,
        region_id: this.region ? this.region.id : undefined,
        distrito_id: this.distrito ? this.distrito.id : undefined,
        materia_id: this.materia ? this.materia.id : undefined,
      };
      this.$store.dispatch("GET_JUZGADOS",  { url: "/juzgados?page=" + this.pagination.current_page, data:this.filtros } ).then(response => {
        this.pagination.current_page = response.data.data.juzgados.current_page;
        this.pagination.total = response.data.data.juzgados.last_page;
        this.listJuzgados = response.data.data.juzgados.data;
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
      });
    },
    onPageChange() {
      this.getJuzgados();
    },
    onFilterChange() {
      this.pagination.current_page = 1;
      this.getJuzgados();
    },
    getMunicipios() {
      this.$store.dispatch("GET_MUNICIPIOS",  { url: "/municipios" } ).then(response => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getMaterias() {
      this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getPartidos() {
      this.$store.dispatch("GET_PARTIDOS",  { url: "partidos-judiciales" } ).then(response => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getDistritos() {
      this.$store.dispatch("GET_DISTRITOS",  { url: "/distritos" } ).then(response => {
        this.listDistritos = response.data.data.distritos
      })
      .catch(err => {
        console.log(err);
      });
    },
    getRegiones() {
      this.$store.dispatch("GET_REGIONES",  { url: "/regiones" } ).then(response => {
        this.listRegiones = response.data.data.regiones
      })
      .catch(err => {
        console.log(err);
      });
    },

    clearZona() {
      this.editedItem.partido_judicial_id = null;
      this.editedItem.distrito_id = null;
      this.editedItem.region_id = null;
    },

    editItem (item) {
      this.editedIndex = this.listJuzgados.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.nombre = this.editedItem.nombre.split(' (')[0]
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },

    addJuzgado(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = this.editedItem;
        this.$store.dispatch("SAVE_JUZGADO",  { url: "/juzgado", data: data } ).then(response => {
          this.close ();
          Swal.fire({
            icon: 'success',
            title: 'Se Guardó Correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getJuzgados();
        })
        .catch(error => {
          console.log(error.response.data);
          if(error.response.data.status){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: error.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: 'Verifique los campos requeridos',
              confirmButtonText: "Aceptar"
            })
          }
        });
      }
      this.loading = false;
    },

    editJuzgado(item){
      //this.dialog=false;
      item.activo = this.activo
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("EDIT_JUZGADO",  { url: "/juzgado/" + item.id, data: item } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Juzgado actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getJuzgados();
        })
        .catch(error => {
          console.log(error);
          if(error.response.data){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: error.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.status,
              confirmButtonText: "Aceptar"
            })
          }
        });
        this.loading = false;
        this.close()
      }
    },

    deleteJuzgado(item){
      this.$swal({
        title: '¿Desea eliminar Juzgado ' + item.nombre + '?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_JUZGADO",  { url: "/juzgado/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Juzgado eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getJuzgados();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },

  }
}
</script>
